import React from 'react'
import PropTypes from 'prop-types'

const PacManIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 254 300"
  >
    <path
      fill="#007AFA"
      fillRule="evenodd"
      d="M186.291 137.91c-14.026 0-25.407-11.384-25.407-25.453 0-14.052 11.38-25.454 25.407-25.454 14.028 0 25.407 11.402 25.407 25.454 0 14.069-11.38 25.453-25.407 25.453M42.317 112.457c0-14.052 11.38-25.454 25.407-25.454 14.028 0 25.407 11.402 25.407 25.454 0 14.069-11.38 25.453-25.407 25.453-14.026 0-25.407-11.384-25.407-25.453M127 0C-.037 0 0 118.782 0 118.782V300l31.773-42.377L63.491 300l31.722-42.377L126.937 300l31.723-42.377L190.385 300l31.75-42.377L253.999 300V118.782S254.036 0 127 0"
    />
  </svg>
)

PacManIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default PacManIcon
